export const NETWORK_MODE = {
    NONE: 0,
    LAN: 1,
    CLOUD: 2,
}